import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">八戒影院</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              八戒影院致力于为用户提供最新电影、电视剧等多种影视内容，涵盖多样类型和题材，满足观影需求和信息查询。
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold text-background-50">影视分类</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/category/movie" className="text-background-300 transition-colors hover:text-secondary-400">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-background-300 transition-colors hover:text-secondary-400">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-background-300 transition-colors hover:text-secondary-400">
                  科幻片
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-background-300 transition-colors hover:text-secondary-400">
                  悬疑片
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold text-background-50">影视资讯</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/news" className="text-background-300 transition-colors hover:text-secondary-400">
                  行业动态
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-background-300 transition-colors hover:text-secondary-400">
                  影评解读
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-background-300 transition-colors hover:text-secondary-400">
                  电影节
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-300 transition-colors hover:text-secondary-400">
                  全站搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold text-background-50">服务与条款</h3>
            <ul className="space-y-2.5 text-sm">
              <li className="text-background-300">
                客服邮箱：<span className="text-background-200">support@bajie-cinema.com</span>
              </li>
              <li className="text-background-300">
                合作邮箱：<span className="text-background-200">bd@bajie-cinema.com</span>
              </li>
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-secondary-400">
                  服务条款
                </Link>
              </li>
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-secondary-400">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© 2026 八戒影院 版权所有 · 本站影视信息与播放均为演示内容</p>
          <p className="flex items-center gap-4">
            <span>内容仅供演示</span>
            <span className="hidden sm:inline">·</span>
            <span>整理归档于 2026 年</span>
          </p>
        </div>
      </div>
    </footer>
  );
}